import React from 'react';
import { Link } from 'react-router-dom';
import GreenLogo from '@design-system/Assets/green-logo.png';
import {
  SigninContainer,
  TextInput,
  Text,
  // Form,
  InputLabel,
  Button,
} from '@design-system/';
import { useDispatch, useSelector } from 'react-redux';
import { getLoading } from './redux/selectors';
import { login } from './redux/reducer';
import * as Yup from 'yup';
import { useFormik } from 'formik';
import AuthFree from '@design-system/UnAuthPage/AuthFree';
import { ForgotPassword, Background } from './style';
import authImage from '@design-system/Assets/auth_image.png';
import apple from '@design-system/Assets/apple_badge.png';
import android from '@design-system/Assets/android_badge.png';
import { Container } from './style';
// import google from '@design-system/Assets/google.png'

export const Signup = () => {
  const loading = useSelector(getLoading);
  const dispatch = useDispatch();

  const formik = useFormik({
    initialValues: {
      email: '',
      password: '',
    },
    onSubmit: async (payload) => {
      dispatch(login(payload));
    },
    validationSchema: Yup.object({
      email: Yup.string()
        .required('Email is required.')
        .email('Invalid email address.'),
      password: Yup.string().required('Password is required.'),
    }),
  });

  return (
    <SigninContainer style={{ overflow: 'hidden' }}>
      <AuthFree />
      <Container>
        <div className="image">
          <img src={GreenLogo} />
        </div>

        <form onSubmit={formik.handleSubmit}>
          <Text size="large" color="#333333" align="left" weight="700">
            Log in
          </Text>

          <Text size="small" align="left" color="#4F4F4F" width="70%" fs="16px">
            Welcome back! Please enter your details.
          </Text>

          <InputLabel htmlFor="email" style={{ marginTop: '32px' }}>
            Email
          </InputLabel>
          <TextInput
            name="email"
            type="email"
            id="email"
            placeholder="Email Address"
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            value={formik.values.email}
          ></TextInput>
          {formik.touched.email && formik.errors.email ? (
            <Text color="red" align="left">
              {formik.errors.email}
            </Text>
          ) : null}
          <InputLabel htmlFor="password" style={{ marginTop: '20px' }}>
            Password
          </InputLabel>
          <TextInput
            name="password"
            type="password"
            id="password"
            placeholder="Password"
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            value={formik.values.password}
          ></TextInput>
          {formik.touched.password && formik.errors.password ? (
            <Text color="red" align="left">
              {formik.errors.password}
            </Text>
          ) : null}

          <ForgotPassword>
            <div className="remember">
              <input type="checkbox" />
              <Text size="small" color="#333333" weight="500">
                Remember me
              </Text>
            </div>
            <Text size="small" align="right" weight="700">
              <Link
                style={{ textDecoration: 'none', color: '#549A9A' }}
                to="/new-password"
              >
                Forgot password?
              </Link>
            </Text>
          </ForgotPassword>

          <Button
            disabled={loading}
            bgColor="#549A9A"
            weight="500"
            style={{ marginTop: 30, marginBottom: 32 }}
            text={loading ? 'Signing in...' : 'Sign in'}
            type="submit"
          />

          <Text size="small" color="#4F4F4F">
            Don&apos;t have an account?{' '}
            <Link style={{ textDecoration: 'none', color: '#549A9A' }} to="./signup">
              Sign Up
            </Link>
          </Text>
        </form>

        {/* </AccessCard> */}
      </Container>

      <Background>
        <div className="content">
          <img src={authImage} alt="authImage" className="mobile-image" />

          <div className="badges-content">
            <Text
              color="#FFFFFF"
              align="center"
              weight="500"
              size="small"
              fs="20px"
              opacity="100%"
            >
              Download the Akaani Mobile App for full experience.
            </Text>
            <div className="badges">
              <a href="https://apps.apple.com/app/akaani-everything-food/id1672711979">
                <img src={apple} alt="apple_badge" />
              </a>

              <a href="https://play.google.com/store/apps/details?id=com.useakaani.vision&pli=1">
                <img src={android} alt="apple_badge" />
              </a>
            </div>
          </div>
        </div>
      </Background>
    </SigninContainer>
  );
};

export default Signup;
